const INPUT_SELECTOR = '.min-max-range';

const MinMaxRangeInput = {
    init: ($scope) => {
        if (!$scope) {
            $scope = $(document);
        }

        const $inputs = $scope.find(INPUT_SELECTOR);

        $inputs.each(function () {
            const wrapper = $(this);
            const slider = wrapper.find('#slider-range');

            // The hidden input fields which are submitted with the form.
            const minField = wrapper.find('input.range-value[name$="[min]"]');
            const maxField = wrapper.find('input.range-value[name$="[max]"]');

            // The labels that are displayed for the values.
            const minDisplay = wrapper.find('p#min-value');
            const maxDisplay = wrapper.find('p#max-value');

            // A label to be used when the min/max has been selected. eg: "36+"
            const minLabel = wrapper.attr('data-min-label');
            const maxLabel = wrapper.attr('data-max-label');

            // The minimum & maximum possible value for the slider
            const sliderMin = parseInt(wrapper.attr('data-min'));
            const sliderMax = parseInt(wrapper.attr('data-max'));

            const intialValues = [
                parseInt(wrapper.attr('data-initial-min')) || 0,
                parseInt(wrapper.attr('data-initial-max')) || parseInt(wrapper.attr('data-max')),
            ];

            const setMin = (value) => {
                const final = value === sliderMin && minLabel ? minLabel : value;
                minField.val(final);
                minDisplay.text(final);
            };
            const setMax = (value) => {
                const final = value === sliderMax && maxLabel ? maxLabel : value;
                maxField.val(final);
                maxDisplay.text(final);
            };

            slider.slider({
                range: true,
                min: sliderMin,
                max: sliderMax,
                values: intialValues,
                slide: (e , { values: [min, max] })  => {
                    setMin(min);
                    setMax(max);
                },
            });

            // Set inital values
            const currMin = slider.slider('values', 0);
            const currMax = slider.slider('values', 1);
            setMin(currMin);
            setMax(currMax);
        });
    },
};

export default MinMaxRangeInput;
